import { FETCH_CUG_PORTFOLIO_LIST_RESPONSE, FETCH_CUG_PAYMENTSCORE_DATA_RESPONSE,
SAVE_CUG_CORPORATE_DATA, FETCH_MONTHS_FILTERS, FETCH_BREAKUP_OF_BUSINESS_DATA_RESPONSE,
FETCH_CUG_LIST_RESPONSE, UPLOAD_CUG_DATA_RESPONSE } from './action';

const initialState = {
    cugPortfoliioList: []
};

const cugPortFolioReducer = (state = initialState, action) => {
    switch (action.type) {
        case FETCH_CUG_PORTFOLIO_LIST_RESPONSE:
            return  {
                ...state,
                cugPortfoliioList: action.data
            }

        case FETCH_CUG_PAYMENTSCORE_DATA_RESPONSE : 
            return {
                ...state,
                cugPaymentScoreData : action.data.data
            }

        case SAVE_CUG_CORPORATE_DATA : 
            return {
                ...state,
                cugCorporateData : action.data
            }

        case FETCH_MONTHS_FILTERS : 
            return {
                ...state,
                monthFiltrs : action.data.data
            }

        case FETCH_BREAKUP_OF_BUSINESS_DATA_RESPONSE :
            return {
                ...state,
                breakupOfBusinessData : action.data.data
            }
        
        case FETCH_CUG_LIST_RESPONSE : 
            return {
                ...state,
                cugListData : action.data.data
            }

        case UPLOAD_CUG_DATA_RESPONSE : 
            return {
                ...state,
                cugDataUploadResponse : action.data
            }

        default:
            return state
    }
}
export default cugPortFolioReducer;